import React, { useState } from 'react';
import './DbmReport.scss';
import { useTranslation } from 'react-i18next';
import {
  GridSortModel,
  GridColDef,
  DataGridPro,
  GridColumnHeaderParams,
  GridPagination
} from '@mui/x-data-grid-pro';
import { IconButton } from '@mui/material';
import CollectiveAgreement from '../CollectiveAgreement/CollectiveAgreement';
import { useEffect } from 'react';
import { useDBM } from '../../providers/DBM';
import { GridPaginationModel } from '@mui/x-data-grid-pro';
import {
  getNumDigits,
  initializeState,
  showAllRows
} from '../../helpers/viewAllHelper';

export default function DbmReport({ dnRates }) {
  const { t } = useTranslation();
  const [isFreeze, setIsFreeze] = useState(false);
  const [isDsc, setIsDsc] = useState(false);
  const dbmContext = useDBM();
  const [tableData, setTableData] = useState<any>({ dbmlist: [] });
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const [xGridColumns, setXGridColumns] = useState<any>([]);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 25
  });
  const [viewAllClicked, setViewAllClicked] = useState(false);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState([25, 50, 100]);

  useEffect(() => {
    if (!dbmContext?.dbmMonthlyData?.dbmlist) {
      return;
    }
    //setTableData({...tableData, dbmlist: []});
    setTableData({
      ...tableData,
      dbmlist: [...dbmContext.dbmMonthlyData.dbmlist]
    });
    if (dbmContext?.dbmMonthlyData?.dbmlist.length !== 0) {
      setIsFreeze(
        dbmContext?.dbmMonthlyData?.dbmlist[0].dbmfreeze === '' ? true : false
      );
      setIsDsc(
        dbmContext?.dbmMonthlyData?.dbmlist[0].dsc === '' ? true : false
      );
    }
    setSortModel([
      {
        field: 'equipment',
        sort: 'asc'
      }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbmContext?.dbmMonthlyData.dbmlist]);

  useEffect(() => {
    initializeState(
      paginationModel,
      setPaginationModel,
      setRowsPerPageOptions,
      viewAllClicked,
      tableData.dbmlist.length
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData.dbmlist, viewAllClicked]);

  const dataWithState = (params) => {
    return isFreeze ? '' : params.value;
  };

  const dscWithState = (params) => {
    return isDsc ? '' : params.value;
  };

  const styleForHeader = () => {
    return isFreeze ? 'grey-header' : '';
  };

  const styleForDsc = () => {
    return isDsc ? 'grey-header' : '';
  };

  const CustomNoRowsOverlay = () => {
    return (
      <div className="no-rows">
        <i className="icon-error-warning" />
        <div>{t('dbmReport.no-data')}</div>
      </div>
    );
  };

  useEffect(() => {
    if (tableData.dbmlist.length) {
      if (paginationModel.pageSize === 25) {
      } else if (paginationModel.pageSize === 50) {
        if (tableData.dbmlist.length <= 25) {
          setPaginationModel({
            ...paginationModel,
            pageSize: 25
          });
        }
      } else if (paginationModel.pageSize === 100) {
        if (tableData.dbmlist.length <= 25) {
          setPaginationModel({
            ...paginationModel,
            pageSize: 25
          });
        } else if (tableData.dbmlist.length <= 50) {
          setPaginationModel({
            ...paginationModel,
            pageSize: 50
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData.dbmlist]);

  const renderHeaderName = (headerName: string) => {
    let firstPart = headerName?.split(' ')[0] ? headerName.split(' ')[0] : '';
    let secondPart = headerName?.split(' ')[1]
      ? headerName.split(' ').slice(1).join(' ')
      : '';
    return (params: GridColumnHeaderParams) => (
      <div className="column-title">
        <p>{firstPart}</p>
        {secondPart !== '' ? <p>{secondPart}</p> : ''}
      </div>
    );
  };

  const generateColumns = (): GridColDef[] => [
    {
      field: '',
      width: 30,
      editable: false,
      sortable: false,
      renderCell: (params) => (
        <div>
          <IconButton disableRipple aria-label="my pairing" size="large">
            {params.row.preferred === true && (
              <span className="icon-profile"></span>
            )}
          </IconButton>
        </div>
      )
    },
    { field: 'baseAirport', headerName: 'Base', width: 110, editable: false },
    {
      field: 'equipment',
      headerName: 'Equipment',
      width: 170,
      editable: false
    },
    { field: 'position', headerName: 'Rank', width: 120, editable: false },
    {
      field: 'dbm',
      renderHeader: renderHeaderName('DBM'),
      width: 130,
      editable: false
    },
    {
      field: 'bhmbg',
      headerName: 'BH MBG',
      editable: false,
      width: 140
    },
    {
      field: 'dsc',
      headerName: 'DSC',
      width: 135,
      editable: false,
      valueGetter: dscWithState,
      headerClassName: styleForDsc,
      sortable: !isDsc
    },
    {
      field: 'estimatedWindow',
      renderHeader: renderHeaderName('Estimated Window'),
      flex: 1,
      minWidth: 90,
      editable: false,
      headerClassName: styleForHeader,
      valueGetter: dataWithState,
      sortable: !isFreeze
    },
    {
      field: 'estimatedBH',
      renderHeader: renderHeaderName('Estimated # of BH'),
      flex: 1,
      minWidth: 90,
      editable: false,
      headerClassName: styleForHeader,
      valueGetter: dataWithState,
      sortable: !isFreeze,
      sortComparator: (a, b) => (a && b ? (+a > +b ? 1 : -1) : -1)
    },
    {
      field: 'estimatedRSV',
      renderHeader: renderHeaderName('Estimated # of RSV'),
      flex: 1,
      editable: false,
      headerClassName: styleForHeader,
      valueGetter: dataWithState,
      sortable: !isFreeze,
      sortComparator: (a, b) => (a && b ? (+a > +b ? 1 : -1) : -1)
    }
  ];

  const columnVisibilityModel = {
  estimatedRSV: false,
  estimatedBH: false,
};


  useEffect(() => {
    setXGridColumns(generateColumns());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFreeze]);

  return (
    <>
      <div className="dbm-report-table">
        <DataGridPro
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
            pagination: (props: any) => (
              <>
                <div
                  className={`view-all-${getNumDigits(paginationModel.pageSize)}`}
                >
                  {paginationModel.pageSize < tableData.dbmlist.length ? (
                    <div className="enabled-view-all">
                      <span
                        onClick={() =>
                          showAllRows(
                            setViewAllClicked,
                            tableData.dbmlist.length,
                            paginationModel,
                            setPaginationModel
                          )
                        }
                      >
                        View All
                      </span>
                    </div>
                  ) : tableData.dbmlist.length > 10 ? (
                    <div className="disabled-view-all">
                      <span>View All</span>
                    </div>
                  ) : (
                    <div className="disabled-view-all-adjusted">
                      <span>View All</span>
                    </div>
                  )}
                </div>
                <GridPagination />
              </>
            )
          }}
          disableColumnMenu
          disableRowSelectionOnClick
          //disableSelectionOnClick
          //disableExtendRowFullWidth={true}
          // pageSize={pageSize}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          pageSizeOptions={rowsPerPageOptions}
          pagination
          getRowId={(r) => r.id}
          rows={tableData.dbmlist}
          columns={xGridColumns}
          columnVisibilityModel={columnVisibilityModel}
          getRowClassName={(params) =>
            params?.row?.preferred === true ? 'profile-row' : ''
          }
          sortModel={sortModel}
          onSortModelChange={(model) => setSortModel(model)}
        />
      </div>
      <div className="foot-notes foot-text"> {t('dbmReport.footNote1')} </div>
      <div className="foot-notes"> {t('dbmReport.footNote2')} </div>

      <CollectiveAgreement ratesWithDates={dnRates} />
    </>
  );
}
